@if (size === ComponentSize.SMALL) {
  <!-- SMALL is used for lists and filters -->
  <osp-tag
    [severity]="severity"
    [border]="false"
    [rounded]="true"
    [ospTooltip]="tooltip"
    [tooltipPosition]="'bottom'"
    [tooltipStyleClass]="'osp-tooltip-xl'"
  >
    <div class="flex gap-1 align-items-center">
      <span class="font-medium text-xs pr-1"><i class="{{ icon }}"></i> {{ label }}</span>
    </div>
  </osp-tag>

} @else {
  <!-- default ComponentSize.LARGE for everything else -->
  <osp-tag
    [severity]="severity"
    [border]="true"
    [rounded]="true"
    [ospTooltip]="tooltip"
    [tooltipPosition]="'bottom'"
    [tooltipStyleClass]="'osp-tooltip-xl'"
  >
    <div class="flex gap-1 align-items-center">
      <osp-icon icon="{{ icon }}" iconSize="large"></osp-icon>
      <span class="font-medium text-xs pr-1">{{ label }}</span>
    </div>
  </osp-tag>
}
